var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAnimatingCorgi)?_c('LottieAnimation',{ref:"anim",staticClass:"running-corgi",attrs:{"animation-data":_vm.runningCorgiAnimation,"auto-play":true,"loop":true,"speed":1}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }